var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleMapsWatchOs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apple_Maps__WatchOS_",
    "data-name": "Apple_Maps_(WatchOS)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3155",
    "data-name": "Ellipse 3155",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38913",
    "data-name": "Group 38913",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13519",
    "data-name": "Rectangle 13519",
    width: 6,
    height: 16,
    fill: "#beb99e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13520",
    "data-name": "Rectangle 13520",
    width: 6,
    height: 16,
    fill: "#e4ddc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13521",
    "data-name": "Rectangle 13521",
    width: 6,
    height: 6,
    transform: "translate(10)",
    fill: "#88ad58"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13522",
    "data-name": "Rectangle 13522",
    width: 6,
    height: 6,
    transform: "translate(10)",
    fill: "#76c63b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13523",
    "data-name": "Rectangle 13523",
    width: 6,
    height: 6,
    transform: "translate(10 10)",
    fill: "#caada2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13524",
    "data-name": "Rectangle 13524",
    width: 6,
    height: 6,
    transform: "translate(10 10)",
    fill: "#fbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28049",
    "data-name": "Path 28049",
    d: "M132,135.992a4,4,0,1,0-4-4A3.956,3.956,0,0,0,132,135.992Z",
    transform: "translate(-123.996 -123.996)",
    fill: "#007aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28050",
    "data-name": "Path 28050",
    d: "M205.139,171.5l-1.639,5.291,1.639-1.842,1.639,1.842Z",
    transform: "translate(-197.139 -166.138)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMapsWatchOs);
export default __webpack_public_path__ + "static/media/Apple_Maps_(WatchOS).447087b13821b2b50e8dbeff2d4b72ca.svg";
export { ForwardRef as ReactComponent };